module.exports = __webpack_public_path__ + "img/devora.d32aca81.png";